<template>
    <div class="row">
        <div class="col-md-12">
            <section class="panel">
                <header class="panel-heading">
                    <h2 class="panel-title">{{pageTitle}}</h2>
                </header>
                <div class="panel-body container-fluid">
                    <div class="form-group">
                        <div class="row form-group">
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">姓&emsp;&emsp;名：</label>
                                {{stuBase.name}}
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">學&emsp;&emsp;制：</label>
                                {{stuBase.deptSsymStr}}
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">性&emsp;&emsp;別：</label>
                                {{stuBase.sexStr}}
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">學&emsp;&emsp;號：</label>
                                {{stuBase.account}}
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">科系班級：</label>
                                {{stuBase.deptCodeStr}}-{{stuBase.drade}}年{{stuBase.dradeClass}}班
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">身分證字號：</label>
                                {{stuBase.idno}}
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5 column-required">聯絡電話：</label>
                                <span v-if="isReadonly" class="col-xs-9 col-md-7">{{stuBase.tel}}</span>
                                <label v-else class="col-xs-9 col-md-7">
                                    <input type="text" name="tel" v-model="stuBase.tel" placeholder="聯絡電話" v-validate="'required|tel'" class="form-control" />
                                    <span class="text-danger" v-show="errors.has('tel')">{{ errors.first('tel') }}</span>
                                </label>
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5 column-required">行動電話：</label>
                                <span v-if="isReadonly" class="col-xs-9 col-md-7">{{stuBase.phone}}</span>
                                <label v-else class="col-xs-9 col-md-7">
                                    <input type="text" name="phone" v-model="stuBase.phone" v-validate="'required|phone'" placeholder="行動電話" class="form-control" />
                                    <span class="text-danger" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
                                </label>
                            </div>
                            <div class="col-md-4 form-group">
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">常用信箱：</label>
                                <span v-if="isReadonly" class="col-xs-9 col-md-7">{{stuBase.extMail}}</span>
                                <label v-else class="col-xs-9 col-md-7">
                                    <input type="email" name="extMail" v-model="stuBase.extMail" placeholder="常用信箱" class="form-control" />
                                </label>
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">學校信箱：</label>
                                <label class="col-xs-9 col-md-7">
                                    {{ stuBase.schMail }}
                                </label>
                            </div>
                            <div class="col-md-4 form-group">
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">家長姓名：</label>
                                {{ stuBase.parentName }}
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">關　　係：</label>
                                {{ stuBase.kinship }}
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="col-xs-3 col-md-5">家長電話：</label>
                                {{ stuBase.parentPhone }}
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-12">
                                <label class="col-xs-4 col-md-2">戶籍地址：</label>
                                <div class="col-xs-8 col-md-10">
                                    {{ stuBase.resiFullAddress }}
                                </div>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-12">
                                <label class="col-xs-4 col-md-2">通訊地址：</label>
                                <div class="col-xs-8 col-md-10">
                                    {{ stuBase.mailFullAddress }}
                                </div>
                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-md-12">
                                <label class="col-xs-4 col-md-2">寢室名稱(房號)：</label>
                                <div class="col-xs-8 col-md-10">
                                    {{dormitoryApply.bedFloor}}-{{dormitoryApply.bedRoom}}-{{dormitoryApply.bed}}-{{dormitoryApply.bedCategory}}
                                </div>
                            </div>
                        </div>

                        <div v-if="storeData.leaveType ==='L'">
                            <div class="row form-group">
                                <div class="col-md-12">
                                    <label class="col-xs-4 col-md-2 column-required">離宿日期：</label>
                                    <div class="col-xs-8 col-md-10" v-if="isReadonly">{{customFormatter(dormitoryLeave.leaveDate)}}</div>
                                    <div class="col-xs-8 col-md-10" v-else>
                                        <datepicker name="leaveDate" v-validate="'required'" :format="customFormatter" :language="zh"
                                                    :disabled-dates="state.disabledDates" v-model="dormitoryLeave.leaveDate" input-class="form-control"
                                                    placeholder="離宿日期" :style="{width:'auto', display:'inline-block'}" :calendarClass="'mobile_size'"
                                                    @input="selectLeaveDate"/>
                                        <span class="text-danger" v-show="errors.has('leaveDate')">{{ errors.first('leaveDate') }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="col-md-12">
                                    <label class="col-xs-4 col-md-2 column-required">離宿時段：</label>
                                    <div class="col-xs-8 col-md-10" v-if="isReadonly">{{dormitoryLeave.leavePeriod}}</div>
                                    <div class="col-xs-8 col-md-10" v-else>
                                        <select name="leavePeriod" v-validate="'required'" v-model="dormitoryLeave.leavePeriod" :disabled="!dormitoryLeave.leaveDate">
                                            <option :value="null">--請選擇--</option>
                                            <option v-for="(item, index) in leavePeriodList" :value="item" :key="index">
                                              {{ item }}
                                            </option>
                                        </select>
                                        <span class="text-danger" v-show="errors.has('leavePeriod')">{{ errors.first('leavePeriod') }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row form-group" v-if="!isReadonly">
                                <div class="col-md-12">
                                    <label class="text-danger">備註說明</label>
                                </div>
                                <div class="col-md-12" style="height:6cm;" v-html="content">
                                </div>
                            </div>
                        </div>
                        <div v-if="storeData.leaveType === 'C'">
                            <div class="row form-group">
                                <div class="col-md-12">
                                    <label class="col-xs-4 col-md-2">存摺局號(本人)：</label>
                                    <div class="col-xs-8 col-md-10">
                                        {{stuBase.bandNo}}
                                    </div>
                                </div>
                            </div>

                            <div class="row form-group">
                                <div class="col-md-12">
                                    <label class="col-xs-4 col-md-2">存摺帳號(本人)：</label>
                                    <div class="col-xs-8 col-md-10">
                                        {{stuBase.bankAccount}}
                                    </div>
                                </div>
                            </div>

                            <div class="row form-group">
                                <div class="col-md-12">
                                    <label class="col-xs-4 col-md-2">是否辦理就學貸款：</label>
                                    <div class="col-xs-8 col-md-10">
                                        {{dormitoryApply.isStuLoanStr}}
                                    </div>
                                </div>
                            </div>

                            <div class="row form-group">
                                <div class="col-md-12">
                                    <label class="col-xs-3 col-md-2 column-required">申請退宿原因：</label>
                                    <div class="col-xs-9 col-md-10">
                                        <div class="col-xs-4 col-md-2" v-if="isReadonly">
                                            {{dormitoryLeave.leaveReasonStr}}
                                        </div>
                                        <div class="col-xs-4 col-md-2" v-else>
                                            <select id="leaveReason" name="leaveReason" v-validate="'required'" class="form-control" v-model="dormitoryLeave.leaveReason">
                                                <option value="">請選擇</option>
                                                <option v-for="(item, index) in leaveReasonList" :key="index" :value="item.commCode">{{item.commValue}}</option>
                                            </select>
                                            <span class="text-danger" v-show="errors.has('leaveReason')">{{ errors.first('leaveReason') }}</span>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="col-md-12">
                                    <label>說明:</label>
                                </div>
                                <div class="col-md-12">
                                    <p v-if="isReadonly">{{dormitoryLeave.leaveRemark}}</p>
                                    <textarea class="form-control" rows="5" name="leaveRemark" v-model="dormitoryLeave.leaveRemark" v-else maxlength="100"></textarea>
                                </div>
                            </div>

                            <div class="row form-group" v-if="dormitoryLeave.leaveReason == '2' || dormitoryLeave.leaveReason == '3' ">
                                <div class="col-md-12">
                                    <label class="column-required">退宿後居住地址：(依申請退宿原因，地址選項會有所不同)</label>
                                </div>
                                <div class="col-md-12" v-if="isReadonly">
                                    <p>{{dormitoryLeave.liveCityStr}}{{dormitoryLeave.liveAreaStr}}{{dormitoryLeave.liveRoadStr}}{{dormitoryLeave.liveAddr}}</p>
                                </div>
                                <div class="col-md-12" v-else>
                                    <div class="col-xs-6 col-md-2 form-group">
                                        <select v-model="dormitoryLeave.liveCityId" name="liveCityId" class="selbox form-control" v-validate="'required'" @change="getLeaveArea">
                                            <option value="">請選擇</option>
                                            <option v-for="(item,key) in cityList" :key="key" :value="item.cityId">{{ item.cityName }}
                                            </option>
                                        </select>
                                        <span class="text-danger" v-show="errors.has('liveCityId')">{{ errors.first('liveCityId') }}</span>
                                    </div>
                                    <div class="col-xs-6 col-md-2 form-group">
                                        <select v-model="dormitoryLeave.liveAreaId" name="liveAreaId" class="selbox form-control" v-validate="'required'" @change="getLeaveRoad">
                                            <option value="">請選擇</option>
                                            <option v-for="(item,key) in areaList" :key="key" :value="item.areaId">{{ item.areaName }}
                                            </option>
                                        </select>
                                        <span class="text-danger" v-show="errors.has('liveAreaId')">{{ errors.first('liveAreaId') }}</span>
                                    </div>
                                    <div class="col-xs-12 col-md-2 form-group" v-if="dormitoryLeave.leaveReason == '3'">
                                        <select v-model="dormitoryLeave.liveRoadId" name="liveRoadId" class="selbox form-control" v-validate="'required'">
                                            <option value="">請選擇</option>
                                            <option v-for="(item,key) in roadList" :key="key" :value="item.roadId">{{ item.roadName }}
                                            </option>
                                        </select>
                                        <span class="text-danger" v-show="errors.has('liveRoadId')">{{ errors.first('liveRoadId') }}</span>
                                    </div>
                                    <div class="col-xs-12 col-md-3 form-group" v-if="dormitoryLeave.leaveReason == '3'">
                                        <input type="text" id="liveAddr" name="liveAddr" v-validate="'required'" class="form-control" v-model="dormitoryLeave.liveAddr" placeholder="地址" maxlength="100" />
                                        <span class="text-danger" v-show="errors.has('liveAddr')">{{ errors.first('liveAddr') }}</span>
                                    </div>
                                </div>

                            </div>
                            <div class="row form-group" v-if="!isReadonly">
                                <div class="col-md-12 form-group">
                                    <label>學生申請自 {{this.dormitoryApply.smtrStr}} 起，申請退宿，並保證遵守下列事項：</label>
                                </div>
                                <div class="col-md-12 form-group">
                                    <label>
                                        <span :style="{color:'#FF0000'}">本人同意下列事項: </span>(同意請打勾) <input type="checkbox" v-validate="'required'" name="isCheckBoxOk" v-model="isCheckBoxOk" />
                                        <span class="text-danger" v-show="errors.has('isCheckBoxOk')">{{ errors.first('isCheckBoxOk') }}</span>
                                    </label>
                                    <p style="margin: 0 !important;padding: 0 !important;">1. 該學年度內不得再申請住校。</p>
                                    <p style="margin: 0 !important;padding: 0 !important;">2. 不得使用或占用宿舍寢室或床位。</p>
                                    <p style="margin: 0 !important;padding: 0 !important;">3. 個人物品於申請後，於三日內立即搬離，否則視同廢棄物處理。</p>
                                    <p style="margin: 0 !important;padding: 0 !important;">4. 入住學生都須遵守宿舍相關規範，如不遵守將視情況予以退宿。</p>
                                </div>
                                <div class="col-md-12 form-group">
                                    <p style="margin: 0 !important;padding: 0 !important;" class="text-danger">退費金額 : {{leaveAmt}}元</p>
                                    <p style="margin: 0 !important;padding: 0 !important;"><small>退費標準：依據學生宿住宿輔導及管理辦法第五條第四款第二項。</small></p>
                                    <p style="margin: 0 !important;padding: 0 !important;"><small>（一）已完成登記繳費，尚未進住宿舍者，全額退費。</small></p>
                                    <p style="margin: 0 !important;padding: 0 !important;"><small>（二）開學後未逾一個月，退還二分之一費用。</small></p>
                                    <p style="margin: 0 !important;padding: 0 !important;"><small>（三）開學後逾一個月未逾兩個月，退還三分之一費用。</small></p>
                                    <p style="margin: 0 !important;padding: 0 !important;"><small>（四）開學後逾二個月退宿，不予退費。</small></p>
                                    <p style="margin: 0 !important;padding: 0 !important;"><small>（五) 因個人因素遭到學校退宿者，一律不予退費。</small></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row form-group" v-if="!isReadonly">
                        <div class="col-md-12">
                            <div class="col-md-offset-4 col-md-2 col-xs-offset-3 col-xs-3">
                                <button @click="handleCancel" class="btn s_btn_g btn-block">取消</button>
                            </div>
                            <div class="col-md-2 col-xs-3">
                                <button @click="handleSave" class="btn btn-primary btn-block">送出申請</button>
                            </div>
                        </div>
                    </div>

                    <div v-if="isStudentView">
                        <div class="row form-group">
                            <div class="col-md-12">
                                <label class="col-xs-4 col-md-2">退費金額：</label>
                                <div class="col-xs-8 col-md-10">{{ leaveAmt }}元</div>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-12">
                                <label class="col-xs-4 col-md-2">申請日期：</label>
                                <div class="col-xs-8 col-md-10">{{ customFormatter(dormitoryLeave.crDate) }}</div>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-12">
                                <label class="col-xs-4 col-md-2">審核狀態：</label>
                                <div class="col-xs-8 col-md-10">{{ leaveStatusStr }}</div>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-12">
                                <label class="col-xs-4 col-md-2">點交狀態：</label>
                                <div class="col-xs-8 col-md-10">{{ dormitoryLeave.leaveAccept === "Y" ? "點交完成" : "尚未點交" }}</div>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-12 text-center">
                                <button class="btn btn-danger" @click="openQrcode" v-if="!qrcodeUrl">開啟 QRCode</button>
                                <button class="btn btn-default" @click="closeQrcode" v-if="qrcodeUrl">關閉 QRCode</button>
                                <div v-if="qrcodeUrl" style="margin-top: 12px;">
                                    <p>請將此 QRCode 出示給宿舍幹部或管理員掃描</p>
                                    <p>此 QRCode 每 5 分鐘自動更新一次</p>
                                    <img :src="qrcodeUrl" alt="qrcode" style="width: 260px; height: 260px;" />
                                    <div style="margin-top: 10px;">
                                        <button class="btn btn-default" @click="copyToClipboard(qrcodeLink)">複製連結</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row form-group" v-if="isReadonly && stuBase.account">
                        <aircon-summary :stu-id="stuBase.account"></aircon-summary>
                    </div>

                    <div class="row form-group" v-if="isStudentView">
                        <div class="col-md-12 text-center">
                            <button @click="handleCancel" class="btn s_btn_g">返回</button>
                        </div>
                    </div>

                    <div class="row form-group" v-if="isMage()">
                        <div class="col-md-12 form-group">
                            <label class="col-xs-3 col-md-2 column-required form-group">{{leaveBelongTitle}}</label>
                            <div class="col-xs-9 col-md-10 form-group">
                                <div class="col-xs-4 col-md-2 " v-for="(item, index) in belongList" :key="index">
                                    <label :for="'belongList_'+index">
                                        <input :id="'belongList_'+index" name="leaveBelong" type="checkbox" :value="item.commCode" v-model="leaveBelong" v-validate="'required'">{{item.commValue}}
                                    </label>
                                </div>
                                <span class="text-danger" v-show="errors.has('leaveBelong')">{{ errors.first('leaveBelong') }}</span>
                            </div>
                        </div>
                        <div class="col-md-12 form-group">
                            <label class="col-xs-3 col-md-2 column-required form-group">環境清潔<br />(寢室及公共區域)：</label>
                            <div class="col-xs-9 col-md-10 form-group">
                                <div class="col-xs-4 col-md-2 " v-for="(item, index) in milieuList" :key="index">
                                    <label :for="'milieuList_'+index">
                                        <input :id="'milieuList_'+index" name="leaveMilieu" type="checkbox" :value="item.commCode" v-model="leaveMilieu" v-validate="'required'">{{item.commValue}}
                                    </label>
                                </div>
                                <span class="text-danger" v-show="errors.has('leaveMilieu')">{{ errors.first('leaveMilieu') }}</span>
                            </div>
                        </div>
                        <div class="col-md-12 form-group">
                            <label class="col-xs-3 col-md-2 form-group">Key：</label>
                            <div class="col-xs-9 col-md-10 form-group">
                                <div class="col-xs-4 col-md-2 " v-for="(item, index) in keyList" :key="index">
                                    <label :for="'keyList_'+index">
                                        <input :id="'keyList_'+index" name="leaveKey" type="checkbox" :value="item.commCode" v-model="leaveKey">{{item.commValue}}
                                    </label>
                                </div>
                                <span class="text-danger" v-show="errors.has('leaveKey')">{{ errors.first('leaveKey') }}</span>
                            </div>
                        </div>
                        <div class="col-md-12 form-group" v-if="isAdmin('stay')">
                            <label class="col-xs-3 col-md-2 column-required form-group">審核狀態：</label>
                            <div class="col-xs-9 col-md-10 form-group">
                                <div class="col-xs-4 col-md-2 ">
                                    <label for="leaveStatus_A">
                                        <input id="leaveStatus_A" name="leaveStatus" type="radio" value="A" v-model="dormitoryLeave.leaveStatus" />待審核
                                    </label>
                                </div>
                                <div class="col-xs-4 col-md-2 ">
                                    <label for="leaveStatus_Y">
                                        <input id="leaveStatus_Y" name="leaveStatus" type="radio" value="Y" v-model="dormitoryLeave.leaveStatus" />審核通過
                                    </label>
                                </div>
                                <div class="col-xs-4 col-md-2 ">
                                    <label for="leaveStatus_N">
                                        <input id="leaveStatus_N" name="leaveStatus" type="radio" value="N" v-model="dormitoryLeave.leaveStatus" />審核不通過
                                    </label>
                                </div>
                                <div class="col-xs-4 col-md-2 ">
                                    <label for="leaveStatus_R">
                                        <input id="leaveStatus_R" name="leaveStatus" type="radio" value="R" v-model="dormitoryLeave.leaveStatus" />退回
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 form-group">
                            <div class="col-md-offset-4 col-md-2 col-xs-offset-3 col-xs-3">
                                <button @click="handleCancel" class="btn s_btn_g btn-block">取消</button>
                            </div>
                            <div class="col-md-2 col-xs-3">
                                <button @click="acceptSave" class="btn btn-primary btn-block">點交完成</button>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </div>
    </div>
</template>

<script>
import { isLeaveApplyReviewMode } from "./leaveApplyMode";
import {
    getVisibleLeaveReasonList,
    resolveLeaveReasonSelection,
} from "./leaveReasonOptions";
import {
    BLOCKING_LEAVE_APPLICATION_MESSAGE,
    hasBlockingLeaveApplication,
} from "./leaveApplicationGuard";
import airconSummary from "./airconSummary.vue";

export default {
    components: { airconSummary },
    props: ["leaveType", "account", "dormitoryType", "idno", "smtr"],
    data() {
        return {
            leaveReasonList: [],
            belongList: [],
            keyList: [],
            milieuList: [],
            cityList: [],
            areaList: [],
            roadList: [],
            lastDate: "",
            stuBase: {},
            dormitoryApply: {},
            dormitoryLeave: {
                applyId: "",
                leaveType: "",
                leaveAmt: null,
                leaveReason: "",
                liveCityId: "",
                liveAreaId: "",
                liveRoadId: "",
                leaveBelong: "",
                leaveMilieu: "",
                leaveKey: "",
            },
            isCheckBoxOk: false,
            leaveAmt: 0,
            leaveBelong: [],
            leaveMilieu: [],
            leaveKey: [],
            leaveDate: null,
            pageTitle: "",
            storeData: {},
            state: {
                disabledDates: {
                  customPredictor: this.leaveDisableDate,
                },
            },
            leaveDatePeriodList: [],
            leavePeriodList: [],
            content: "",
            hasExistingLeaveRecord: false,
            isStudentView: false,
            qrcodeUrl: "",
            qrcodeLink: "",
            refreshTimerId: null,
        };
    },
    async mounted() {
        if (this.getStore(this.$route.name) != null) {
            this.storeData = JSON.parse(this.getStore(this.$route.name));
        }
        if (this.storeData.leaveType == "C") {
            this.pageTitle = "退宿申請表";
        } else if (this.storeData.leaveType == "L") {
            this.pageTitle = "離宿申請表";
            // 取得可離宿日期時段
            const api = "/api/room/getDormitoryLeaveDatePeriod";
            const query = new URLSearchParams({
              startDate: this.customFormatter(new Date()),
              endDate: ''
            }).toString();
            this.$axios.get(api + '?' + query).then(resp =>{
              this.leaveDatePeriodList = resp.data.data.rows;
            });
        }
        let _this = this;
        const api = "/api/Room/leaveInit";
        this.$axios.post(api).then((resp) => {
            _this.cityList = resp.data.data.cityList;
            _this.keyList = resp.data.data.keyList;
            _this.milieuList = resp.data.data.milieuList;
            _this.belongList = resp.data.data.belongList;
            _this.leaveReasonList = getVisibleLeaveReasonList(resp.data.data.leaveReasonList, {
                fromDeduct: !!_this.storeData.fromDeduct,
                forceGuaranteeOnly: !!_this.storeData.forceGuaranteeOnly,
                currentLeaveReason: _this.dormitoryLeave.leaveReason,
            });
            _this.dormitoryLeave.leaveReason = resolveLeaveReasonSelection(_this.dormitoryLeave.leaveReason, {
                fromDeduct: !!_this.storeData.fromDeduct,
                forceGuaranteeOnly: !!_this.storeData.forceGuaranteeOnly,
            });
            _this.lastDate = resp.data.data.lastDate;
            if (_this.leaveBelong.length === 0) {
                _this.leaveBelong = _this.belongList.map(item => item.commCode);
            }
            if (_this.leaveMilieu.length === 0) {
                _this.leaveMilieu = _this.milieuList.map(item => item.commCode);
            }
        });

      this.$axios.get(`/api/common/treaty?type=stay-leave`).then(resp => {
        this.content = this.htmlDecode(resp.data.content);
      });

        await this.init();
    },
    methods: {
        resolveLeaveAmt() {
            if (!this.dormitoryApply || this.dormitoryApply.ensureAmt == null) {
                return 0;
            }

            if (this.dormitoryLeave && this.dormitoryLeave.leaveAmt != null) {
                return this.dormitoryLeave.leaveAmt;
            }

            if (this.storeData.forceGuaranteeOnly) {
                return this.dormitoryApply.ensureAmt;
            }

            if (this.storeData.leaveType !== "C") {
                return this.dormitoryApply.ensureAmt;
            }

            const intoRoomDate = this.dormitoryApply.intoRoomDate ? new Date(this.dormitoryApply.intoRoomDate) : null;
            if (!intoRoomDate || intoRoomDate > new Date()) {
                return this.dormitoryApply.roomAmt + this.dormitoryApply.ensureAmt;
            }

            const oneMonth = new Date(this.dormitoryApply.intoRoomDate);
            oneMonth.setMonth(oneMonth.getMonth() + 1);
            const twoMonth = new Date(this.dormitoryApply.intoRoomDate);
            twoMonth.setMonth(twoMonth.getMonth() + 2);
            if (new Date() < oneMonth) {
                return Math.round(this.dormitoryApply.roomAmt / 2) + this.dormitoryApply.ensureAmt;
            }
            if (new Date() < twoMonth) {
                return Math.round(this.dormitoryApply.roomAmt / 3) + this.dormitoryApply.ensureAmt;
            }
            return this.dormitoryApply.ensureAmt;
        },
        async init() {
            const initParam = {
                account: this.storeData.account,
                idno: this.storeData.idno,
                id: this.storeData.id,
            };
            const api = "/api/Room/roomInfo";
            let resp = await this.$axios.post(api, initParam);
            const _this = this;
            if (resp.data.status === "success") {
                if ("stuBase" in resp.data.data) {
                    this.stuBase = resp.data.data.stuBase;
                }
                if ("dormitoryApply" in resp.data.data) {
                    this.dormitoryApply = resp.data.data.dormitoryApply;
                    this.leaveAmt = this.resolveLeaveAmt();
                    this.hasExistingLeaveRecord = !!this.dormitoryApply.tbDormitoryLeave;
                    if (this.dormitoryApply.tbDormitoryLeave) {
                        if (this.storeData.fromDeduct && hasBlockingLeaveApplication(this.dormitoryApply.tbDormitoryLeave.leaveStatus)) {
                            bootbox.alert(BLOCKING_LEAVE_APPLICATION_MESSAGE, function () {
                                _this.$router.go(-1);
                            });
                            return;
                        }
                        this.dormitoryLeave = this.dormitoryApply.tbDormitoryLeave;
                        this.leaveAmt = this.resolveLeaveAmt();
                        if (!this.isMage() && this.dormitoryLeave.leaveStatus != "R") {
                            // 已有申請單:同一頁改為唯讀檢視(顯示審核狀態並可出示 QRCode)
                            this.isStudentView = true;
                        }
                        if (this.dormitoryLeave.liveCityId) {
                            this.getLeaveArea();
                        } else {
                            this.dormitoryLeave.liveCityId = "";
                        }
                        if (this.dormitoryLeave.liveAreaId) {
                            this.getLeaveRoad();
                        } else {
                            this.dormitoryLeave.liveAreaId = "";
                        }
                        if (!this.dormitoryLeave.liveRoadId) {
                            this.dormitoryLeave.liveRoadId = "";
                        }
                        if (!this.dormitoryLeave.leaveReason) {
                            this.dormitoryLeave.leaveReason = "";
                        }
                        this.leaveReasonList = getVisibleLeaveReasonList(this.leaveReasonList, {
                            fromDeduct: !!this.storeData.fromDeduct,
                            forceGuaranteeOnly: !!this.storeData.forceGuaranteeOnly,
                            currentLeaveReason: this.dormitoryLeave.leaveReason,
                        });
                        this.dormitoryLeave.leaveReason = resolveLeaveReasonSelection(this.dormitoryLeave.leaveReason, {
                            fromDeduct: !!this.storeData.fromDeduct,
                            forceGuaranteeOnly: !!this.storeData.forceGuaranteeOnly,
                        });
                        if (this.dormitoryLeave.leaveBelong) {
                            let leaveBelongJson = JSON.parse(this.dormitoryLeave.leaveBelong);
                            let belongArr = [];
                            for (let k in leaveBelongJson) {
                                if (leaveBelongJson[k] === "Y") {
                                    belongArr.push(k);
                                }
                            }
                            this.leaveBelong = belongArr;
                        }
                        if (this.dormitoryLeave.leaveMilieu) {
                            let leaveMilieuJson = JSON.parse(this.dormitoryLeave.leaveMilieu);
                            let milieuArr = [];
                            for (let k in leaveMilieuJson) {
                                if (leaveMilieuJson[k] === "Y") {
                                    milieuArr.push(k);
                                }
                            }
                            this.leaveMilieu = milieuArr;
                        }
                        if (this.dormitoryLeave.leaveKey) {
                            let leaveKeyJson = JSON.parse(this.dormitoryLeave.leaveKey);
                            for (let k in leaveKeyJson) {
                                if (leaveKeyJson[k] === "Y") {
                                    this.leaveKey.push(k);
                                }
                            }
                        }
                    }
                }
                if (this.dormitoryLeave.leaveDate) {
                  this.selectLeaveDate();
                }
            } else {
                bootbox.alert(resp.data.msg, function () {
                    _this.$router.go(-1);
                });
            }
        },
        handleCancel() {
            this.$router.go(-1);
        },
        handleSave() {
            const _this = this;
            this.$validator.validateAll().then((result) => {
                if (result) {
                    const api = "/api/Room/saveApplyRoomLeave";
                    this.dormitoryLeave.applyId = this.dormitoryApply.id;
                    this.dormitoryLeave.leaveType = this.storeData.leaveType;
                    this.dormitoryLeave.leaveAmt = this.leaveAmt;
                    this.dormitoryLeave.leaveReason = resolveLeaveReasonSelection(this.dormitoryLeave.leaveReason, {
                        fromDeduct: !!this.storeData.fromDeduct,
                        forceGuaranteeOnly: !!this.storeData.forceGuaranteeOnly,
                    });
                    this.dormitoryLeave.forceGuaranteeOnly = !!this.storeData.forceGuaranteeOnly;
                    let requestDormitoryLeave = {};
                    for (let k in this.dormitoryLeave) {
                        if (this.dormitoryLeave[k]) {
                            requestDormitoryLeave[k] = this.dormitoryLeave[k];
                        }
                    }
                    this.$axios.post(api, JSON.stringify(requestDormitoryLeave)).then((resp) => {
                        let status = resp.data.status;
                        bootbox.alert(resp.data.msg, function () {
                            if (status === "success") {
                                _this.$router.go(-1);
                            }
                        });
                    });
                } else {
                    bootbox.alert("請確認必填欄位是否有填寫");
                }
            });
        },
        acceptSave() {
            this.$validator.validateAll().then((result) => {
                if (!result && (this.dormitoryLeave == "Y" || this.dormitoryLeave == "N")) {
                    bootbox.alert("請確認必填欄位是否有填寫");
                    return false;
                }
                let leaveBelong = {};
                for (let i in this.belongList) {
                    let tmp = this.leaveBelong.filter((x) => {
                        return x == this.belongList[i].commCode;
                    });
                    if (tmp.length > 0) {
                        leaveBelong[this.belongList[i].commCode] = "Y";
                    } else {
                        leaveBelong[this.belongList[i].commCode] = "N";
                    }
                }
                let leaveMilieu = {};
                for (let i in this.milieuList) {
                    let tmp = this.leaveMilieu.filter((x) => {
                        return x == this.milieuList[i].commCode;
                    });
                    if (tmp.length > 0) {
                        leaveMilieu[this.milieuList[i].commCode] = "Y";
                    } else {
                        leaveMilieu[this.milieuList[i].commCode] = "N";
                    }
                }
                let leaveKey = {};
                for (let i in this.keyList) {
                    let tmp = this.leaveKey.filter((x) => {
                        return x == this.keyList[i].commCode;
                    });
                    if (tmp.length > 0) {
                        leaveKey[this.keyList[i].commCode] = "Y";
                    } else {
                        leaveKey[this.keyList[i].commCode] = "N";
                    }
                }
                this.dormitoryLeave.leaveBelong = JSON.stringify(leaveBelong);
                this.dormitoryLeave.leaveMilieu = JSON.stringify(leaveMilieu);
                this.dormitoryLeave.leaveKey = JSON.stringify(leaveKey);
                if (this.leaveBelong.length > 0 && this.leaveMilieu.length > 0) {
                    this.dormitoryLeave.leaveAccept = "Y";
                } else {
                    this.dormitoryLeave.leaveAccept = "N";
                }
                let requestDormitoryLeave = {};
                for (let k in this.dormitoryLeave) {
                    if (this.dormitoryLeave[k]) {
                        if (k == "leaveDate") {
                            requestDormitoryLeave[k] = this.customFormatter(this.dormitoryLeave[k]);
                        } else {
                            requestDormitoryLeave[k] = this.dormitoryLeave[k];
                        }
                    }
                }
                const api = "/api/Room/saveApplyRoomLeaveAccept";
                this.$axios.post(api, requestDormitoryLeave).then((resp) => {
                    let status = resp.data.status;
                    bootbox.alert(resp.data.msg, function () {
                        if (status == "success") {
                            // 點交可能是從 QRCode 掃碼進來(沒有上一頁),完成後整頁導回系統首頁
                            window.location.href = "/";
                        }
                    });
                });
            });
        },
        async getLeaveArea() {
            if (this.baseDataIsNotEmpty) {
                this.dormitoryLeave.liveAreaId = "";
                this.dormitoryLeave.liveRoadId = "";
                this.areaList = [];
                this.roadList = [];
                const api = "/api/Common/getArea/" + this.dormitoryLeave.liveCityId;
                let resp = await this.$axios.post(api);
                if (resp.data.status == "success") {
                    this.areaList = resp.data.data.areaList;
                }
            }
        },
        async getLeaveRoad() {
            if (this.baseDataIsNotEmpty) {
                this.dormitoryLeave.liveRoadId = "";
                this.roadList = [];
                const api = "/api/Common/getRoad/" + this.dormitoryLeave.liveAreaId;
                let resp = await this.$axios.post(api);
                if (resp.data.status == "success") {
                    this.roadList = resp.data.data.roadList;
                }
            }
        },
        isMage() {
            return isLeaveApplyReviewMode({
                isAdminStay: this.isAdmin("stay"),
                sessionAccountType: this.sessionData.accountType,
                sessionIsRoomMage: this.sessionData.isRoomMage,
                sessionAccount: this.sessionData.account,
                targetAccount: this.storeData.account,
                fromDeduct: !!this.storeData.fromDeduct,
                hasExistingLeaveRecord: this.hasExistingLeaveRecord,
            });
        },
        lastDateFormat(leaveDate) {
            const dayList = ["日", "一", "二", "三", "四", "五", "六"];
            let rocDate = leaveDate.getFullYear() - 1911 + "年" + (leaveDate.getMonth() + 1) + "月" + leaveDate.getDate() + "日(星期" + dayList[leaveDate.getDay()] + ")";
            return rocDate;
        },
        leaveDisableDate(date) {
          let d = this.customFormatter(date);
          return !this.leaveDatePeriodList.find(dp => this.customFormatter(dp.date) == d);
        },
        selectLeaveDate() {
          this.leavePeriodList = this.leaveDatePeriodList.find(dp => this.customFormatter(dp.date) == this.customFormatter(this.dormitoryLeave.leaveDate)).periods;
        },
        clearRefreshTimer() {
            if (this.refreshTimerId) {
                clearInterval(this.refreshTimerId);
                this.refreshTimerId = null;
            }
        },
        closeQrcode() {
            this.clearRefreshTimer();
            this.qrcodeUrl = "";
            this.qrcodeLink = "";
        },
        openQrcode() {
            const refresh = () => {
                this.$axios
                    .post("/api/Room/generateLeaveQrcodeToken", { applyId: this.dormitoryApply.id })
                    .then((resp) => {
                        if (resp.data.status !== "success") {
                            this.closeQrcode();
                            bootbox.alert(resp.data.msg || "QRCode 產生失敗");
                            return;
                        }
                        const data = resp.data.data;
                        this.qrcodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=260x260&data=${encodeURIComponent(data.url)}`;
                        this.qrcodeLink = data.url;
                    });
            };
            refresh();
            this.clearRefreshTimer();
            this.refreshTimerId = setInterval(refresh, 5 * 60 * 1000);
        },
    },
    computed: {
        leaveBelongTitle() {
            let str = "";
            if (this.storeData.leaveType === "L") {
                str = "離宿財產清單";
            } else if (this.storeData.leaveType === "C") {
                str = "退宿財產清單";
            }
            return str;
        },
        baseDataIsNotEmpty() {
            return !this.jsonIsEmpty(this.dormitoryLeave);
        },
        isReadonly() {
            return this.isMage() || this.isStudentView;
        },
        leaveStatusStr() {
            const map = { A: "待審核", Y: "審核通過", N: "審核不通過", R: "退回" };
            return map[this.dormitoryLeave.leaveStatus] || "";
        },
    },
    watch: {},
    beforeDestroy() {
        this.clearRefreshTimer();
    },
    beforeRouteLeave(to, from, next) {
        this.removeStore(this.$route.name);
        next();
    },
};
</script>

<style>
.mobile_size {
    width: auto;
}
</style>
